import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  // Customers do NOT get forced to change password (they use phone as default)
  if (user.must_change_password && user.role !== "customer" && path !== "/change-password")
    return <Navigate to="/change-password" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "super_admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
